import { Component, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ObservationService } from '../../../observations/services/observation.service';
import { AuthenticationService, LoaderService, MultiTenantService, RouteService, ToastService, ToolbarService } from '@kaiser-software/chassis-core';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { LocationModel } from '../../../locations/models/location.model';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';

@Component({
    selector: 'app-account-dashboard',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
})
export class AccountDashboardComponent implements OnInit, OnDestroy {

    public $locations: Subject<Array<LocationModel>> = new ReplaySubject(1);

    public startDate: string;

    public endDate: string;

    public filters: {
        startDate?: number,
        endDate?: number,
    } = {};

    public reload$ = new BehaviorSubject(null);

    public dateIntervalName = 'last-24-hours';

    protected subscription = new Subscription();

    constructor(
        protected observationService: ObservationService,
        protected routeService: RouteService,
        protected router: Router,
        protected auth: AuthenticationService,
        protected toastService: ToastService,
        protected toolbarService: ToolbarService,
        protected loaderService: LoaderService,
        protected tenantService: MultiTenantService
    ) {
        //
    }

    public ngOnInit(): void {
        this.addToolbarRefreshButton();

        this.loadLocations();

        this.filterLast24Hours();
    }

    protected addToolbarRefreshButton(): void {
        this.toolbarService.add({
            icon: 'fal fa-sync',
            text: 'Refresh Dashboard',
            name: 'refresh-dashboard',
            callback: () => {
                this.reload();
            },
        });
    }

    public reload(): void {
        this.reload$.next(
            Math.random() * Math.random()
        );
    }

    public clearDates(): void {
        this.startDate = null;
        this.endDate   = null;

        this.filters = {};
    }

    protected updateFilters(): void {
        const filters: any = {};

        if (this.startDate) {
            filters.startDate = moment(this.startDate)
                .unix();
        }

        if (this.endDate) {
            filters.endDate = moment(this.endDate)
                .unix();
        }

        this.filters = filters;
    }

    private loadLocations(): void {
        this.subscription.add(
            combineLatest(this.auth.user$, this.tenantService.getScope(), this.reload$)
                .pipe(
                    filter(([user]) => {
                        return !!user.tenants;
                    })
                )
                .subscribe(([user, scope]) => {
                    const locations = user.tenants
                        .filter((tenant) => {
                            return !!tenant.parent_id
                                && (tenant.id === scope
                                    || tenant.parent_id === scope);
                        });

                    this.$locations.next(locations);
                })
        );
    }

    public filterRange(startDate: Moment, endDate: Moment): void {
        this.startDate = startDate.toISOString();
        this.endDate   = endDate.toISOString();

        console.log(this.startDate, this.endDate);

        this.updateFilters();
    }

    public filterLast24Hours(): void {
        this.dateIntervalName = 'last-24-hours';

        this.filterRange(
            moment().subtract(1, 'day'),
            moment(),
        );
    }

    public filterToday(): void {
        this.dateIntervalName = 'today';

        this.filterRange(
            moment().startOf('day'),
            moment().endOf('day'),
        );
    }

    public filterYesterday(): void {
        this.dateIntervalName = 'yesterday';

        this.filterRange(
            moment().subtract(1, 'day').startOf('day'),
            moment().subtract(1, 'day').endOf('day'),
        );
    }

    public filterLastWeek(): void {
        this.dateIntervalName = 'last-week';

        this.filterRange(
            moment().subtract(1, 'week').startOf('week'),
            moment().subtract(1, 'week').endOf('week'),
        );
    }

    public filterLastMonth(): void {
        this.dateIntervalName = 'last-month';

        this.filterRange(
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
        )
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();

        this.toolbarService.clear();
    }
}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/dashboards/pages/account/account.component.ts